// extracted by mini-css-extract-plugin
export default {"welcomeMessage":"UserPanel_welcomeMessage__4JZ1C","login":"UserPanel_login__raD9F","welcome":"UserPanel_welcome__0azLE"};